import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'what_percentage_workers_are_paid_mobile_money'

export const dataPointDefinition = {
  retracedId: 'what_percentage_workers_are_paid_mobile_money',
  name: 'What percentage of workers are paid by mobile money?',
  description: 'Enter a decimal number. E.g., for 100% enter 1.0. For 75% enter 0.75.',
  meta: {
    slcpMeta: {
      key: 'wb-15-4f',
      number: 'WB-WAGE-102',
      dataType: 'numeric-percentage',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],wb-15-4x',
      machineShowHide: '[2],wb-15-4x',
      completionCondition: 'any',
    },
    unit: 'PERCENTAGE',
    min: 0,
    max: 100,
  },
  fieldTypeId: 'NUMBER_UOM',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-15-4f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34990,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
